export const accessibleStyle = {
  type: 'ComponentStyle',
  styleType: 'custom',
  style: {
    propertiesOverride: {
      fnt: {
        fontFamily: 'helvetica-w01-light',
        fontWeight: 'normal',
      },
    },
    properties: {
      'alpha-txth': '1',
      bgh: '#FFFFFF',
      shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
      rd: '0px',
      'alpha-brdh': '1',
      txth: '#000000',
      'alpha-brd': '1',
      'alpha-bg': '1',
      bg: '#000000',
      txt: '#FFFFFF',
      'alpha-bgh': '1',
      brw: '1',
      fnt: 'font_8',
      brd: '#FFFFFF',
      'boxShadowToggleOn-shd': 'false',
      'alpha-txt': '1',
      brdh: '#000000',
    },
    propertiesSource: {
      'alpha-txth': 'value',
      bgh: 'value',
      shd: 'value',
      rd: 'value',
      'alpha-brdh': 'value',
      txth: 'value',
      'alpha-brd': 'value',
      'alpha-bg': 'value',
      bg: 'value',
      txt: 'value',
      'alpha-bgh': 'value',
      brw: 'value',
      fnt: 'theme',
      brd: 'value',
      'boxShadowToggleOn-shd': 'value',
      'alpha-txt': 'value',
      brdh: 'value',
    },
    groups: {},
  },
  componentClassName: 'wysiwyg.viewer.components.PopupCloseTextButton',
  pageId: '',
  compId: '',
  skin: 'wysiwyg.viewer.skins.button.BasicButton',
  metaData: {
    schemaVersion: '1.0',
    isPreset: false,
    isHidden: false,
    pageId: 'usihs',
    sig: 'xgp-985',
  },
};

export const accessibleCloseIconButtonSystemId =
  'f9827bfe-e2d0-4a95-b8f2-6308aa952d55';
